import { MerchantId, SetHeaderService } from "@/helper/authenticationHelper";
import { DocumentTemplateHeaderTypeModel, DocumentWithPassCodeModel } from "@/model/document/documentModel";
import service from "../../baseHttpService";
import {
  PrepareDocumentInputData,
  PrepareDocumentPublicLinkInputData,
  PrepareUpdateDetailDocumentInputData,
} from "../documentFacade";

class CreditNoteExpenseService {
  DoGetCreditNotExpenseDocumentPublicLink(input: DocumentWithPassCodeModel) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareDocumentPublicLinkInputData(input),
    };
    return service.peakOnlineView
      .post("/api/CreditNote/GetCreditNoteExpenseDocumentPublicLink", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetCreditNoteExpenseDocument(input: DocumentTemplateHeaderTypeModel) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareDocumentInputData(input),
    };
    return service.peakOnlineView
      .post("/api/CreditNote/GetCreditNoteExpenseDocument", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoUpdateCreditNoteExpenseDetail(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareUpdateDetailDocumentInputData(input),
    };
    return service.peakOnlineView
      .post("/api/CreditNote/UpdateCreditNoteExpenseDetailDocument", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
}
export default new CreditNoteExpenseService();
